import { render, staticRenderFns } from "./Beijing.vue?vue&type=template&id=cac255ce&"
import script from "./Beijing.vue?vue&type=script&lang=js&"
export * from "./Beijing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports